module.exports = __webpack_public_path__ + "static/media/diy.827f623d.svg";